import * as React from 'react';

import { NodeProps, Position } from '@xyflow/react';
import { Clock } from 'lucide-react';

import { BaseNode } from '../../BaseNode';
import type { NodeVisualDefinition, TriggerNode } from '../../types';

import {
  ScheduleTriggerConfigType,
  getScheduleTriggerPreviewText,
} from './schema';

/** Typed node for schedule trigger */
type ScheduleTriggerNodeType = TriggerNode<ScheduleTriggerConfigType>;

/** Visual definition for the Schedule Trigger node */
export const scheduleTriggerVisualDefinition: NodeVisualDefinition = {
  key: 'ScheduleTrigger',
  label: 'Schedule',
  description: 'Trigger on a recurring schedule',
  icon: Clock,
  color: 'warning',
  handles: [
    {
      type: 'source',
      position: Position.Bottom,
      className: 'bg-gray!',
    },
  ],
  getContent: getScheduleTriggerPreviewText as (
    config: Record<string, unknown>,
  ) => string,
};

/**
 * Visual component for Schedule Trigger nodes on the canvas.
 */
export const ScheduleTriggerNode = React.memo<
  NodeProps<ScheduleTriggerNodeType>
>((props) => (
  <BaseNode
    {...props}
    definition={scheduleTriggerVisualDefinition}
    className="@ScheduleTriggerNode"
  />
));

ScheduleTriggerNode.displayName = 'ScheduleTriggerNode';
